import { REACT_APP_SITEWEB_VOB2C_URL } from "../../../constants/env";

export const redirectToSouscription = () => {
  if (!REACT_APP_SITEWEB_VOB2C_URL) return;
  window.location.href = REACT_APP_SITEWEB_VOB2C_URL;
};
